import React from 'react';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import axios from "../axios";
import { Services } from "../api/api";

import Dashboard from "../Dashboard";
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";

export default function ServiceRead() {
  const { id } = useParams<{
    id: string;
  }>();
  const navigation = useNavigate();

  const [data, setData] = useState<Services>({});
  const [update, setUpdate] = useState<boolean>(false);

  useEffect(() => {
    axios.get("/services/" + id).then((res) => {
      setData(res.data);
    });
  }, [id, update]);

  const handleEdit = () => {
    navigation("/services/update/" + id);
  };

  const dateValue = (date: Date | undefined) => {
    if (date !== undefined) {
      return date!.toString().substring(0,19).replace('T', ' ');
    } else {
      return "";
    }
  };

  return (
    <Dashboard title="サービス管理">
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>{data.id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>サービスID</TableCell>
            <TableCell>{data.service_id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>サービス名</TableCell>
            <TableCell>{data.service_name}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>作成日時</TableCell>
            <TableCell>{dateValue(data.created_at)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>更新日時</TableCell>
            <TableCell>{dateValue(data.updated_at)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>備考</TableCell>
            <TableCell>
              <TextField
                required
                multiline
                fullWidth
                value={data.memo}
                inputProps={{ readonly: true, disabled: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleEdit} sx={{ m: 1 }}>
          EDIT
        </Button>
      </Grid>
    </Dashboard>
  );
}
